/*
IMPORTANT:
This file is used both in vue2 and vue3
Dont use the vue syntax and the store concept in this file.
For any clarifications please contact Leela
*/

export class VideoPopupSession {
  static VideoPopupSessionExists(pageName) {
    if (!sessionStorage.getItem(window.tid + pageName)) {
      let key = window.tid + pageName;
      sessionStorage.setItem(key, window.tid);
      return false;
    }
    return true;
  }
}
